/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Calledbackat2Inputs */

const de__field_calledbackat2 = /** @type {(inputs: _Field_Calledbackat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zurückgerufen am (OS-Akquise)`)
};

/**

* @param {_Field_Calledbackat2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_calledbackat2 = /** @type {((inputs?: _Field_Calledbackat2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Calledbackat2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_calledbackat2(inputs)
});
export { _field_calledbackat2 as "_field_calledBackAt" }